const InclusionExclusion = ({ inclusions = [], exclusions = [] }) => {
    return (
        <div className="p-4 max-w-7xl mx-auto bg-white border rounded-lg shadow">
            <h2 className="text-xl font-semibold text-custom-blue p-2">What's inside the package?</h2>
            <hr className="border-1 mt-4" />

            <div className="flex flex-col md:flex-row md:justify-between">
                {/* Inclusions */}
                <div className="p-4 w-full md:w-1/2">
                    <h3 className="font-bold text-custom-blue mb-4">Inclusions</h3>
                    <ul className="list-none pl-1 pr-4">
                        {inclusions.map((item, index) => (
                            <li key={index} className="flex text-custom-blue items-center mb-1">
                                <img src="/success.png" alt="check" className="w-4 h-4 mr-2" />
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Divider Line */}
                <div className="h-px bg-gray-300 mx-4 md:w-px md:h-auto md:mx-2" />

                {/* Exclusions */}
                <div className="p-4 w-full md:w-1/2">
                    <h3 className="font-bold text-custom-blue mb-4">Exclusions</h3>
                    <ul className="list-none pl-1">
                        {exclusions.map((item, index) => (
                            <li key={index} className="flex text-custom-blue items-center mb-1">
                                <img src="/close.png" alt="cross" className="w-4 h-4 mr-2" />
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default InclusionExclusion;